import cx from 'classnames';
import { useAtom } from 'jotai';
import { FunctionComponent, useState } from 'react';
import {
  Zoom,
  Navigation,
  Pagination,
  Keyboard,
  Thumbs,
  FreeMode,
  Mousewheel,
} from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';

// Import Swiper styles
import useIsMobile from '../../../../hooks/use-is-mobile';
import IconGallery from '../../icons/gallery';

import classes from './image-group.module.css';
import { targetItem } from './state';
import { SwiperButtonZoomIn, SwiperButtonZoomOut } from './zoomButton';
import Image from 'next/image';
import BPImage from '../../v2/image';

const ImageGallery: FunctionComponent<{
  list: any;
  altExtraInfo?: string;
}> = ({ list, altExtraInfo }) => {
  const [target, setTarget] = useAtom(targetItem);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const isMobile = useIsMobile();

  return (
    <>
      <Swiper
        spaceBetween={0}
        className="w-full lg:w-full h-full max-lg:h-[calc(100%-134px)] flex flex-col swiperConfig"
        slidesPerView={1}
        onSlideChange={(e) => {
          setTarget(e.realIndex);
        }}
        effect="fade"
        zoom={true}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        virtualIndex={target}
        style={{
          '--swiper-navigation-color': '#f6f5f5',
          '--swiper-pagination-color': '#f6f5f5',
        }}
        initialSlide={target}
        keyboard={{
          enabled: true,
        }}
        thumbs={{ swiper: thumbsSwiper }}
        mousewheelControl={true}
        mousewheel={true}
        loop={true}
        modules={[Zoom, Keyboard, Navigation, Pagination, Thumbs, Mousewheel]}
      >
        <SwiperButtonZoomIn />
        <SwiperButtonZoomOut />
        <div className="absolute p-2 bg-bparts-100 top-4 left-4 text-base font-bold text-white rounded-md flex gap-2 items-center justify-center z-10">
          <IconGallery className="w-6 h-6"></IconGallery>
          {list.length}
        </div>
        {list.map((img: any, index: number) => {
          return (
            <SwiperSlide
              className=" bg-neutral-80 w-full h-full aspect-video"
              zoom={true}
              key={index}
            >
              <div className="swiper-zoom-container" data-swiper-zoom="5">
                <img
                  className={cx('w-full h-full object-cover')}
                  src={img.src}
                  alt={`${altExtraInfo ? altExtraInfo + ' ' : ''}`}
                  fetchPriority={index === 0 ? 'high' : 'low'}
                />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={isMobile ? 3 : 5}
        freeMode={false}
        direction={isMobile ? 'horizontal' : 'vertical'}
        watchSlidesProgress={true}
        watchSlidesVisibility
        centeredSlides
        centeredSlidesBounds
        modules={[FreeMode, Navigation, Thumbs, Mousewheel]}
        mousewheelControl={true}
        mousewheel={{
          enabled: true,
        }}
        loop={true}
        className={cx(
          'h-[100px] lg:h-full w-[250px] lg:w-[400px] max-lg:w-full max-lg:!px-0 !px-8 !pb-4 !swiper-vertical gallery-thumbs',
          classes.thumbnailsList
        )}
      >
        {list.map((img: any, index_: number) => {
          return (
            <SwiperSlide
              className={cx(
                'h-[100px] lg:h-[full] w-full lg:w-[400px]  aspect-video',
                classes.imageHover,
                {
                  [classes.thumbnailActive]:
                    target.toString() === index_.toString(),
                }
              )}
              key={index_}
            >
              <img
                className={cx('w-full h-full object-cover')}
                alt={`${altExtraInfo ? altExtraInfo + ' ' : ''}`}
                src={img.src_big}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default ImageGallery;
